import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import RankingDashboardPanel from '../../core/components/RankingDashboardPanel'
import i18n from '../i18n'

class ProviderDashboardPanel extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            providers: []
        }
    }

    componentWillMount() {
        const {aggregations} = this.props
        
        const providers = aggregations.assignees.filter((a) => a.ref == 'ProviderContact')
        this.setState({providers})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.aggregations != this.props.aggregations) {
            const {aggregations} = nextProps
            
            const providers = aggregations.assignees.filter((a) => a.ref == 'ProviderContact')
            this.setState({providers})
        }
    }

    _navigate(event, provider) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push('/providercontacts/' + provider.value))
    }

    render() {
        const {dispatch, aggregations, ...others} = this.props
        const {providers} = this.state

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )
        
        return (
            <RankingDashboardPanel
                header={panelHeader(i18n.providersTop10)}
                display={(p) => p.label + ' (' + p.count + ')'}
                identify={(p) => p.count}
                onClick={(e, p) => this._navigate(e, p)}
                value={providers}
                {...others} />
        )
    }
}

ProviderDashboardPanel = connect((state) => ({
	aggregations: state.ticket.aggregations
}))(ProviderDashboardPanel)

export default ProviderDashboardPanel


// WEBPACK FOOTER //
// ./lib/ticket/components/ProviderDashboardPanel.js